<div class="slider">
  <button
    type="button"
    [attr.aria-label]="'common.sliderWithControls.decrease' | translate"
    [disabled]="disabled()"
    (click)="stepBy(-1)"
  >
    <fr8bot-ui-icon name="minus-16" [size]="16" />
  </button>

  <fr8bot-ui-slider-field
    [(value)]="value"
    [minValue]="minValue()"
    [maxValue]="maxValue()"
    [step]="step()"
    [defaultValue]="defaultValue()"
    [disabled]="disabled()"
    (touch)="touch.emit()"
  />

  <button
    type="button"
    [attr.aria-label]="'common.sliderWithControls.increase' | translate"
    [disabled]="disabled()"
    (click)="stepBy(1)"
  >
    <fr8bot-ui-icon name="plus-16" [size]="16" />
  </button>
</div>
